import { render, staticRenderFns } from "./SubModulo.vue?vue&type=template&id=efb62b08"
import script from "./SubModulo.vue?vue&type=script&lang=ts"
export * from "./SubModulo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports